/*=========================================================================================
File Name: store.js
Description: Vuex store
----------------------------------------------------------------------------------------
Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
Author: Pixinvent
Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
/* eslint-disable array-bracket-newline */
// import Vue from 'vue'
// import Vuex from 'vuex'
// Vue.use(Vuex)

import Vue from 'vue'
import Vuex from 'vuex'

import persist from './persist'
import app from './modules/app'
import auth from './auth'
import authError from './authError'
import wovn from './wovn'
import order from './order'
import modal from './modal'
import bs_app from './modules/bs_app'
import bs_inf from './modules/bs_inf'
import menu from './modules/menu'
import plan from './modules/plan'
import order_old from './modules/order'
import menu_info from './modules/menu_info'
import service from './modules/service'
import spec from './modules/spec'
import createPersistedState from 'vuex-persistedstate'
import mypage from './modules/bs_myp'
import bsSet from './modules/bs_set'
import coupon from './coupon'
import * as Cookies from 'js-cookie'
import CONST_DATA from '@/mixins/const/constData'
// ライフエール独自対応 >>>>>
import loadingCrly from "@crly/store/loading.js";
import loginInfo from "./loginInfo";
import userInfo from "@crly/store/user.js";
import clickNewsCookie from "@crly/store/clickNews.js";
import clickNewsLStorage from "@crly/store/clickNews.js";
import resisterDate from "@crly/store/resisterDate.js";
import navOrderCookie from "@crly/store/categoryOrder.js";
import navOrderLStorage from "@crly/store/categoryOrder.js";
import opinionState from "@crly/store/opinionState.js";
import mailState from "@crly/store/mailState.js";
import menuStatus from "@crly/store/menuStatus.js";
// ライフエール独自対応 <<<<<

Vue.use(Vuex)

//
const namespacedModules = {
  // ライフエール独自対応 >>>>>
  loadingCrly,
  loginInfo,
  userInfo,
  clickNewsCookie,
  clickNewsLStorage,
  resisterDate,
  navOrderCookie,
  navOrderLStorage,
  opinionState,
  mailState,
  menuStatus,
  // ライフエール独自対応 <<<<<
  persist,
  auth,
  authError,
  wovn,
  order,
  modal,
}



export default new Vuex.Store({
  ...app,
  modules: {
    ...Object.keys(namespacedModules).reduce((acc, k) => {
      acc[k] = {
        ...namespacedModules[k],
        namespaced: true
      }
      return acc
    }, {}),
    bs_app,
    bs_inf,
    menu,
    plan,
    order_old,
    menu_info,
    service,
    mypage,
    spec,
    bsSet,
    coupon
  },
  strict: process.env.NODE_ENV !== CONST_DATA.ENV.PRODUCTION,
  plugins: [
    // ライフエール独自対応 >>>>>
    createPersistedState({
      key: "crlyC",
      paths: ["opinionState", "loginInfo", "resisterDate", "mailState"],
      // ストレージの種類を指定
      storage: {
        getItem: (key) => Cookies.get(key),
        setItem: (key, value) =>
          Cookies.set(key, value, {
            domain: process.env.VUE_APP_COOKIE_DOMAIN,
            expires: 7,
            secure: true
          }), // 7日間有効
        removeItem: (key) => Cookies.remove(key)
      }
    }),
    createPersistedState({ 　
      key: "crlyCOrder",
      paths: ["navOrderCookie"],
      storage: {
        getItem: (key) => Cookies.get(key),
        setItem: (key, value) =>
          Cookies.set(key, value, {
            domain: process.env.VUE_APP_COOKIE_DOMAIN,
            expires: 3650,
            secure: true
          }), // 最大10年間有効（Chromeは400日、Safariは7日 2023/6/20現在）
        removeItem: (key) => Cookies.remove(key)
      }
    }),
    createPersistedState({
      key: "crlyCNews",
      paths: ["clickNewsCookie"],
      storage: {
        getItem: (key) => Cookies.get(key),
        setItem: (key, value) =>
          Cookies.set(key, value, {
            domain: process.env.VUE_APP_COOKIE_DOMAIN,
            expires: 3650,
            secure: true
          }), // 最大10年間有効（Chromeは400日、Safariは7日 2023/6/20現在）
        removeItem: (key) => Cookies.remove(key)
      }
    }),
    createPersistedState({
      key: "crly",
      paths: ["navOrderLStorage","clickNewsLStorage"],
      // ストレージの種類を指定
      storage: window.localStorage
    }),
    // ライフエール独自対応 <<<<<
    createPersistedState({
      key: "bsBenefitOneInc",
      paths: ["order", "plan"],
      storage: window.sessionStorage
    }),
  ]
})
